import { Component, inject, OnInit } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { MatFormFieldModule } from '@angular/material/form-field';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { Router } from '@angular/router';

const MODULES: any[] = [
  MatButtonModule,
  MatIconModule,
  MatFormFieldModule,
  FormsModule,
  ReactiveFormsModule,
];

@Component({
  selector: 'app-noAccount',
  standalone: true,
  imports: [MODULES],
  templateUrl: './no-account.component.html',
  styleUrl: './no-account.component.css',
})
export class NoAccountComponent {
  constructor(private router: Router) {
  }

  returnToLogin() {
    this.router.navigate(['']);
  }

}
